import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";
import towageThumbnail from "../../../../assets/img/caseStudies/towage.webp";
import dev4Logo from "../../../../assets/img/branding/Logos/D4 Full Logo Colour.webp";

export default function TowageManagement() {
 const caseStudy = new CaseStudyTemplate(
  "Shipping: Towage Management Tool ",
  (
   <div>
    <p>
     Towage brokering operates around the clock, demanding instant access to vessel locations and reliable contact management to respond swiftly to maritime emergencies. The client required a tailored system to streamline operations, integrate with external platforms, and enable immediate action.
    </p>

    <p>
     DEV4 designed, built, and continues to support a custom towage management tool tailored to the high-pressure demands of international ship brokering. The system: </p>
    <ul>
     <li>Maintains comprehensive contact records for all relevant stakeholders.</li>
     <li>Integrates with external data sources for real-time global vessel tracking.</li>
     <li>Enables brokers to identify and dispatch the nearest available vessel during emergencies—enhancing response times and efficiency.</li>
    </ul>
    <strong>The Results</strong>
    <ul>
     <li>Faster Emergency Response: Brokers can now act in real time to safeguard vessels and cargo.</li>
     <li>Reliable Operations: Continuous availability with seamless third-party integration.</li>
     <li>Long-Term Support: DEV4 remains an active partner, evolving the system alongside the client’s needs.</li>
    </ul>
    <p>Intitial system build time: 7 months | Established in 2014 | User base: One of the largest global ship brokers managed from London |</p>
   </div>
  ),
  towageThumbnail,
  new Company(
   "",
   "",
   {
    width: "0%",
   }
  ),
  "",
  [
   technologies.PWA,
   technologies.netCore,
   technologies.blazor,
   technologies.sqlServer,
   technologies.azure
  ]
 )

 return (
  <CaseStudy caseStudy={caseStudy} bgColor="rgb(0,0,0,0)" thumbSize="105%"></CaseStudy>
 )
}